interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-1.5" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page === 1}
        className={`flex h-9 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border px-3 text-[12px] transition-colors ${
          page === 1
            ? 'cursor-not-allowed border-background-200 text-foreground-300'
            : 'border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
        }`}
      >
        <span className="flex h-3.5 w-3.5 items-center justify-center">
          <i className="ri-arrow-left-s-line text-sm" />
        </span>
        上一页
      </button>

      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          aria-current={item === page ? 'page' : undefined}
          className={`flex h-9 w-9 cursor-pointer items-center justify-center rounded-md text-[12px] transition-colors ${
            item === page
              ? 'bg-primary-600 text-background-50'
              : 'border border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-700'
          }`}
        >
          {item}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page === totalPages}
        className={`flex h-9 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border px-3 text-[12px] transition-colors ${
          page === totalPages
            ? 'cursor-not-allowed border-background-200 text-foreground-300'
            : 'border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
        }`}
      >
        下一页
        <span className="flex h-3.5 w-3.5 items-center justify-center">
          <i className="ri-arrow-right-s-line text-sm" />
        </span>
      </button>
    </nav>
  );
}